export { TabBar } from './TabBar';
export type { TabItem, TabBarProps } from './TabBar';
